import React, { useEffect, useState } from "react";
import { Box, makeStyles, Menu, MenuItem, Typography } from "@material-ui/core";
import icon11 from "../../Images/Icon11.svg";
import icon1 from "../../Images/Icon1.svg";
import icon3 from "../../Images/Icon3.svg";
import { Link, useHistory } from "react-router-dom";
import StatusSummaryDrawer from "../Roles/Organization/ManageInfo/StatusSummaryDrawer";
import DataService from "../../Service";
import moment from "moment";

const options = [
  {
    id: 1,
    title: "Current assignments",
    icon: icon1,
    route: "/ManageInfo",
  },
  { id: 2, title: "Assignment statistics", icon: icon3, route: "" },
  { id: 3, title: "Dashboard", icon: icon3, route: "/dashboard", },
];

const Option = ({ title, icon }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb="46px"
    >
      <Typography
        variant="body1"
        style={{ color: "#fff", lineHeight: "24px", fontSize: "16px" }}
      >
        {title}
      </Typography>
      <Box
        minWidth="64px"
        height="64px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor="white"
        borderRadius="32px"
      >
        <img src={icon} style={{ height: "27px" }} alt={title} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  menu: {
    "& .MuiPaper-root": {
      padding: "10px 21px",
      width: "350px",
      height: "313px",
      right: "17px",
      bottom: "58px",
      left: "unset !important",
      top: "unset !important",
      background:
        "transparent linear-gradient(220deg, #077F83 0%, #014c4e 80%, #014c4e 100%) 0% 0% no-repeat padding-box;",
      border: "1px solid #707070",
      borderRadius: "24px 24px 0px 0px",
      boxShadow: "unset",
      borderBottomColor: '#470000',

      '&:hover': {
        backgroundColor: "rbg(7,121,131)",
        color: "none"
      }
    },

  },
  menuItem: {
    '&:hover': {
      backgroundColor: "rbg(7,121,131)",
      color: "none"
    }
  }

}));

export default function ShotcutPopup(props) {

  const classes = useStyles();
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawer, setDrawer] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawer = () => {
    var flag = true
    setDrawer(true)
    setAnchorEl(null);
    history.push({ pathname: "/ManageInfo/Statistics", state: flag })
    // history.goBack()
  }

  return (

    <div className={classes.root} >
      <Box
        width="76px"
        height="76px"
        borderRadius="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        boxShadow="rgb(7 121 131) 0px 3px 6px"
        ml="43px"
        style={{ cursor: "pointer" }}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <img src={icon11} style={{ height: "30px" }} alt="call request" />
      </Box>
      <Menu
        id="simple-menu"
        className={classes.menu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Link to={{ pathname: "/ManageInfo" }} style={{ textDecoration: "none" }} className={classes.menuItem}>
          <MenuItem className={classes.menuItem} >

            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb="26px" className={classes.menuItem}
            >
              <Typography
                variant="body1"
                style={{ color: "#fff", lineHeight: "24px", fontSize: "16px", textDecoration: "none" }}
              >
                Current assignments
              </Typography>
              <Box
                minWidth="64px"
                height="64px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="white"
                borderRadius="32px"

                marginLeft="91px"

              >
                <img src={icon1} style={{ height: "27px" }} alt=" Assignment statistics" />
              </Box>
            </Box>
          </MenuItem></Link>
        {/* <Link to={{ pathname: "/ManageInfo ", state: { flag: true } }} > */}
        <MenuItem onClick={handleDrawer}>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb="26px" className={classes.menuItem}
          >
            <Typography
              variant="body1"
              style={{ color: "#fff", lineHeight: "24px", fontSize: "16px", textDecoration: "none" }}
            >
              Assignment statistics
            </Typography>
            <Box
              minWidth="64px"
              height="64px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgcolor="white"
              borderRadius="32px"
              marginLeft="91px"
            >
              <img src={icon3} style={{ height: "27px" }} alt=" Assignment statistics" />
            </Box>
          </Box>
        </MenuItem>
        {/* </Link> */}
        <Link to={{ pathname: "/dashboard" }} style={{ textDecoration: "none" }}>
          <MenuItem onClick={handleDrawer}>

            <Typography
              variant="body1"
              style={{ color: "#fff", lineHeight: "24px", fontSize: "16px", }}
            >
              Dashboard
            </Typography>
            <Box
              minWidth="64px"
              height="64px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgcolor="white"
              borderRadius="32px"
              marginLeft="165px"
            >
              <img src={icon3} style={{ height: "27px" }} alt=" Assignment statistics" />
            </Box>

          </MenuItem></Link>

        {/* <Box width="100%" margin="0 auto">
          {options.map((item) => (

            <Link to={item.route}>
              <Option key={item.id} title={item.title} icon={item.icon} /></Link>
          ))}
        </Box> */}
      </Menu>

    </div >


  );
}
